<template>
  <div>
    <div class="pl" v-for="(item, index) in list" :key="index">
      <div class="user-info">
        <div class="user-head">
          <van-image
            fit="cover"
            width="100%"
            height="100%"
            :src="item.avatar"
            alt=""
          />
        </div>
        <div class="user-i">
          <p class="user-name">{{ item.user || item.name }}</p>
          <p class="pl-time">{{ item.created_time }}</p>
        </div>
        <div class="cp" v-if="state">
          <p>
            已购买：<span> {{ item.consultTitle || item.cName }} </span>
          </p>
        </div>
      </div>
      <div class="ly" v-if="tabshow">
        <div v-for="(lab, i) in (item.tagsTitle || item.tags)" :key="i">{{ lab }}</div>
      </div>
      <div class="pl-text">{{ item.content }}</div>

      <div class="pl-ls" v-if="zxshow">
        <div class="pl-ls-img">
          <van-image
            fit="cover"
            width="100%"
            height="100%"
            :src="item.teacher.avatar"
            alt=""
          />
        </div>
        <div class="pl-ls-inof">
          <p class="pl-ls-name">{{ item.teacher.name }}</p>
          <p class="pl-ls-p">￥{{ item.teacher.price }}</p>
        </div>

        <div
          class="pl-ls-zx"
          @click="
            $router.push({
              path: '/teacherDetails',
              query: { id: item.teacher.id },
            })
          "
        >
          立即咨询
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/**
@description:评论
@createTime:2021-09-03
@create:wq
*/
export default {
  name: "",
  props: {
    tabshow: {
      default: false,
    },
    zxshow: {
      default: false,
    },
    state: {
      default: false,
    },
    list: {
      default: [],
    },
  },
  components: {},
  data() {
    return {};
  },
  computed: {},
  watch: {},
  mounted() {},
  created() {},
  methods: {},
};
</script>
<style lang="scss" scoped>
.pl {
  margin-bottom: 0.44rem;
  overflow: hidden;
  padding-bottom: 0.24rem;
  border-bottom: 1px solid #f0f0f0;
  .user-info {
    display: flex;
    align-items: flex-end;
    margin-bottom: 0.26rem;

    .user-head {
      width: 0.8rem;
      height: 0.8rem;
      border: 2px solid #ffffff;
      box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.16);
      border-radius: 50%;
      overflow: hidden;
      box-sizing: border-box;
      margin-right: 0.12rem;
      display: flex;
      justify-content: center;
      align-items: center;
      img {
        width: 100%;
      }
    }
    .user-i {
      flex: 1;
      .user-name {
        font-size: 0.32rem;
        font-weight: bold;
        color: #333333;
      }
      .pl-time {
        font-size: 0.24rem;
        font-weight: 400;
        color: #cccccc;
      }
    }

    .cp {
      font-size: 0.24rem;
      font-weight: 400;
      color: #999999;
      span {
        color: #4fd9d5;
      }
    }
  }
  .pl-text {
    margin-left: 0.92rem;
    font-size: 0.28rem;
    font-weight: 400;
    color: #666666;
    // margin-top: 0.24rem;
  }
  .pl-ls {
    width: 5.78rem;
    height: 1.14rem;
    padding: 0 0.32rem;
    box-sizing: border-box;
    background-color: #f6f8f8;
    border-radius: 0.2rem;
    margin-top: 0.16rem;
    float: right;
    display: flex;
    align-items: center;
    .pl-ls-img {
      width: 0.84rem;
      height: 0.84rem;
      border: 0.04rem solid #ffffff;
      margin-right: 0.3rem;
      display: flex;
      align-items: center;
      justify-content: center;
      overflow: hidden;
      border-radius: 50%;
      img {
        width: 100%;
      }
    }
    .pl-ls-inof {
      flex: 1;
      .pl-ls-name {
        font-size: 0.28rem;
        font-weight: bold;
        color: #333333;
      }
      .pl-ls-p {
        font-size: 0.3rem;
        font-weight: 400;
        color: #f05468;
      }
    }
    .pl-ls-zx {
      width: 1.64rem;
      height: 0.6rem;
      background: rgba(79, 217, 213, 0.1);
      border: 2px solid #4fd9d5;
      border-radius: 0.35rem;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 0.26rem;
      font-weight: 400;
      color: #4fd9d5;
    }
  }
  .ly {
    display: flex;
    flex-wrap: wrap;
    margin-left: 0.92rem;
    > div {
      height: 0.36rem;
      background: #ffeedf;
      border-radius: 0.22rem;

      font-size: 0.2rem;
      font-weight: 400;
      color: #ffa380;
      padding: 0 0.2rem;
      margin-right: 0.1rem;
      margin-bottom: 0.2rem;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
}
</style>
